import {combineReducers} from "redux";

import addVideoReducer from "./addVideo";

export default combineReducers({
    addVideo: addVideoReducer
});